import {ConfigState, QuickLinks, Announcement} from '../reducers/config/types';
import {safelyToJS} from './utils';

export const selectRTL = (state): boolean => state.getIn(['config', 'isRTL']);

export const selectConfig = (state): ConfigState => safelyToJS(state.get('config'));

export const selectAnnouncements = (state): Announcement[] =>
    safelyToJS(state.getIn(['config', 'announcements']));

export const selectAnnouncementsLength = (state): number =>
    safelyToJS(state.getIn(['config', 'announcements'])).length;

export const selectQuickLinks = (state): QuickLinks =>
    safelyToJS(state.getIn(['config', 'quickLinks']));

export const selectEnableMigration = (state): boolean =>
    state.getIn(['config', 'enableV2Migration']);

export const selectEnableReactivation = (state): boolean =>
    state.getIn(['config', 'enableReactivation']);

export const selectEnableTalon = (state): boolean => state.getIn(['config', 'enableTalon']);

export const selectStoreBaseUrl = (state): string => state.getIn(['config', 'baseStoreUrl']);
